var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M40 10a10 10 0 1019.99.01A10 10 0 0040 10zm0 40a10 10 0 1019.99.01A10 10 0 0040 50zm0 40a10 10 0 1019.99.01A10 10 0 0040 90z", "fill-rule": "nonzero" } }] }, name: "more", theme: "filled" };
export {
  e as default
};
